import React, {useState, useEffect, Fragment} from 'react';
import './App.css';
import Header from './layouts/Header';
import SideBar from './layouts/SideBar';
import Footer from './layouts/Footer';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SideBarDesktop from './layouts/SideBarDesktop';
import { Routes, Route } from "react-router-dom";
import Index from './components/Home/Index';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Wallet from './components/Wallet/Wallet';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Register from './components/Auth/Register';
import Login from './components/Auth/Login';
import { useSelector } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import MissingRoute from './components/MissingRoute';
import ListNotifications from './components/Notifications/ListNotifications';
import FetchNotifications from './request/Notifications/FetchNotifications';
import Profile from './components/Settings/Profile';

// admin routes
import UploadProducts from './components/Admin/UploadProducts';
import ListPlates from './components/Admin/ListPlates';
import CreatePlans from './components/Admin/CreatePlans';
import PushNotification from './components/Settings/PushNotification';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRedirect } from './components/Auth/historySlice';
import Referrals from './components/Referrals/Referrals';
import AdminMail from './components/Admin/Mail/AdminMail';
import UserDashboard from './components/Admin/User/UserDashboard';
import ListTransfer from './components/Admin/User/ListTranfers';
import Forgot from './components/Auth/Forgot';
import UpdatePassword from './components/Auth/UpdatePassword';
import AdminSms from './components/Admin/Mail/AdminSms';
// import FetchAnalysis from './request/Analysis/FetchAnalysis';
// import AdminAnalysis from './components/Admin/AdminAnalysis';
// import ChartAnalysis from './request/Analysis/ChartAnalysis';
import LoadFundings from './request/Funding/LoadFundings';
import LoadPlans from './request/Plans/LoadPlans';
import InvestmentPlans from './components/plans/InvestmentPlans';
import FetchCoinRates from './request/CoinRates/FetchConRates';
import FetchCountriesAndCurrencies from './request/Countries/FetchCountriesAndCurrencies';
import AccountHistory from './request/Analysis/AccountHistory';
import Withdrawals from './components/Withdrawal/Withdrawals';
import Investment from './components/Investment/Investment';
import Transactions from './components/Transactions/Transactions';
import Invitation from './components/Home/Invitation';
import LoadReferrals from './request/Referrals/LoadReferrals';
import ListUsers from './components/Admin/ListUsers';
import ListPlans from './components/Admin/ListPlans';
import EditPlan from './components/Admin/EditPlan';
import ListInvestments from './components/Admin/ListInvestments';
import DepayTransactions from './components/Admin/DepayTransactions';
import CoinremitterTransactions from './components/Admin/CoinremitterTransactions';
import WithdrawalList from './components/Admin/WithdrawalList';
import CreateAddress from './components/Admin/CreateAddress';
import ListAddresses from './components/Admin/ListAddresses';
import Editwallet from './components/Admin/EditAddress';
import ListFundings from './components/Admin/ListFundings';
import GetRates from './request/Earning/GetRates';
import LoadUser from './request/User/LoadUser';
import LoadP2POffers from './request/P2P/LoadP2POffers';
import LiveChatWidget from './components/Chat/LiveChatWidget';
import CheckAuth from './request/Auth/CheckAuth';
import Cards from './components/Cards/Cards';
import Shareholders from './components/Shareholders/Shareholders';
import Loans from './components/Loans/Loans';
import ListCards from './components/Admin/ListCards';
import ListShareholders from './components/Admin/ListShareholders';
import ListLoans from './components/Admin/ListLoans';
import MarketsAccount from './components/Markets/MarketsAccounts';


import Receive from './components/Pages/Receive';
import SendCoin from './components/Pages/SendCoin';
import DefaultTrader from './components/Trader/DefaultTrader';
import SwapCoin from './components/Swap/SwapCoin';
import NewWallet from './components/Wallet/NewWallet';
import CreateTradingPlans from './components/Admin/CreateTradingPlans';
import ListTradingPlan from './components/Admin/ListTradingPlan';
import EditTradingPlan from './components/Admin/EditTradingPlan';
import LoadTradingPlans from './request/Plans/LoadTradingPlans';
import TradeHistory from './components/Trader/TradeHistory';
import StartTrading from './components/Trader/StartTrading';
import SpotTransfer from './components/Swap/SpotTransfer';
import CreateCategories from './components/Admin/CreateCategories';
import CategoryPlans from './components/plans/categoryPlans';



import FetchTraders from './request/Traders/FetchTraders';
import Traders from './components/Traders/Traders';
import TraderSingle from './components/Traders/TraderSingle';
import ListTraders from './components/Admin/ListTraders';
import CopyHistory from './components/Traders/CopyHistory';
import CopySingle from './components/Traders/CopySingle';


import EditTrader from './components/Admin/EditTrader';
import ListTrades from './components/Admin/ListTrades';
import EditTrade from './components/Admin/EditTrade';
import ListCopiers from './components/Admin/ListCopiers';
import Editcopier from './components/Admin/EditCopies';
import CreateTrades from './components/Admin/CreateTrades';
import CreateTrader from './components/Admin/CreateTrader';
import EditInvestment from './components/Admin/EditInvestment';
import Buy from './components/P2P/Buy';
import Sell from './components/P2P/Sell';
import P2P from './components/P2P/P2P';
import Buyer from './components/P2P/Buyer';
import Seller from './components/P2P/Seller';
import P2PPartnerDashboard from './components/P2P/P2PPartnerDashboard';
import P2PAdminDashboard from './components/Admin/P2PAdminDashboard';
import P2PTransactionDetails from './components/P2P/P2PTransactionDetails';
import P2POrderDetails from './components/P2P/P2POrderDetails';
import P2PHistory from './components/P2P/P2PHistory';
import Transaction from './components/Transactions/Transaction';

import CreateMessage from './components/Admin/CreateMessage';
import FetchMessages from './request/Messages/FetchMessages';
import Assets from './components/Wallet/Assets';
import Web3 from './components/Web3/Web3';
import ListConnections from './components/Admin/ListConnections';
import TradeTab from './components/BybitTrade/TradeTab';
import CoinChart from './components/BybitTrade/CoinChart';
import ListStock from './components/Stock/ListStock';
// import LiveChatWidget from './components/Chat/LiveChatWidget';
import LiveChatAdmin from './components/Admin/LiveChatAdmin';
import ListReferral from './components/Admin/ListReferrals';

// PWA Install Prompt
import PWAInstallPrompt from './components/PWA/PWAInstallPrompt';
import PWAUpdateNotification from './components/PWA/PWAUpdateNotification';

// Page Wrapper Component for consistent footer spacing
const PageWrapper = ({ children }) => (
  <Box sx={{ 
    marginTop: '75px',
    paddingBottom: { xs: '100px', md: '20px' },
    minHeight: 'calc(100vh - 75px)'
  }}>
    {children}
  </Box>
);

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const queryClient = new QueryClient();

function App() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open2, setOpen2] = React.useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleToggle2 = () => {
    setOpen2(!open2);
  };

  const user = useSelector((state) => state.user.user);
  const mode = useSelector((state) => state.mode.mode);
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const userRole = useSelector((state) => state.user.currentRole);

  
  const [message, setMessage] = useState(null);

  const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(true);
      };
    const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setOpen(false);
  };
  
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#F7931A',
        light: '#FFB800',
        dark: '#E8841A',
        contrastText: '#FFFFFF'
      },
      secondary: {
        main: '#02C076',
        light: '#00D4AA',
        dark: '#018A5B',
        contrastText: '#FFFFFF'
      },
      error: {
        main: '#F84960',
        light: '#FF6B85',
        dark: '#E03852'
      },
      warning: {
        main: '#FFB800',
        light: '#FFC947',
        dark: '#CC9300'
      },
      success: {
        main: '#02C076',
        light: '#00D4AA',
        dark: '#018A5B'
      },
      background: {
        default: '#0B0E11',
        paper: '#161A1E'
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#B7BDC6',
        disabled: '#5E6673'
      },
      divider: '#2B3139',
      custom: {
        main: '#FFFFFF',
        cardBg: '#161A1E',
        borderPrimary: '#2B3139'
      }
    },
    typography: {
      fontFamily: ['Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
      h1: {
        fontFamily: ['Playfair Display', 'serif'].join(','),
        fontWeight: 700,
        letterSpacing: '-0.02em'
      },
      h2: {
        fontFamily: ['Playfair Display', 'serif'].join(','),
        fontWeight: 600,
        letterSpacing: '-0.01em'
      },
      h3: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 600,
        letterSpacing: '-0.01em'
      },
      h4: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 600
      },
      h5: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 600
      },
      h6: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 600
      },
      body1: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 400,
        lineHeight: 1.5
      },
      body2: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 400,
        lineHeight: 1.5
      },
      caption: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        fontWeight: 500,
        color: '#B7BDC6'
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '14px',
            transition: 'all 0.3s ease'
          },
          contained: {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)'
            }
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            background: 'linear-gradient(145deg, rgba(22, 26, 30, 0.8) 0%, rgba(31, 35, 41, 0.6) 100%)',
            border: '1px solid #2B3139',
            borderRadius: '12px',
            backdropFilter: 'blur(10px)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              borderColor: '#F7931A',
              transform: 'translateY(-2px)',
              boxShadow: '0 0 20px rgba(247, 147, 26, 0.3)'
            }
          }
        }
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              background: '#1F2329',
              borderRadius: '8px',
              '& fieldset': {
                borderColor: '#2B3139'
              },
              '&:hover fieldset': {
                borderColor: '#F7931A'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#F7931A',
                boxShadow: '0 0 0 3px rgba(247, 147, 26, 0.2)'
              }
            }
          }
        }
      }
    }
  });

  useEffect(() => {
   
    window.addEventListener('newMessage', function (e) {
      const notification = JSON.parse(localStorage.getItem('notification'));
      if (notification) {
        
        if (notification.message === 'Unauthenticated.') {
          let pathName = window.location.pathname;
          dispatch(setRedirect(pathName));
          setMessage(notification);
          handleClick();
          setTimeout(() => {
            navigate('/login');
          }, 1000);
          
        }else{
          setMessage(notification);
          handleClick();
  
        }
      }
  }, false); 

  window.addEventListener('processing', function (e) {
    handleToggle2();
}, false); 
window.addEventListener('processed', function (e) {
  handleClose2();
}, false);

  }, [user]);

  if (isAuth) {
    return (
      <div className="App">
        <QueryClientProvider client={queryClient}>
          <PWAInstallPrompt />
          <PWAUpdateNotification />
          <CheckAuth/>
          <FetchCoinRates/>
          <FetchCountriesAndCurrencies/>
          <FetchNotifications/>   
          <LoadFundings/> 
          <LoadPlans/>  
          <LoadTradingPlans/>
          <AccountHistory/>
          <FetchMessages/>
          <LoadReferrals/>
          <FetchTraders/>
          <GetRates/>
          <LoadUser/>
          <LoadP2POffers/>
        <ThemeProvider theme={darkTheme} >
        <CssBaseline />
        <Header/>
        <SideBar/>
          <Grid container spacing={0}>
            <Grid sx={{display: {md: 'flex', sm: 'none', xs: 'none'}}} item md={2}>
            <SideBarDesktop/>
            </Grid>
            <Grid item xs={12} md={10}>
              <PageWrapper>
              <Routes>   
                {userRole === 'admin' ? <Route path='/' element={<Index/>} /> : <Route path='/' element={<Index/>} /> }
                <Route path='/copy-plans' element={<Traders/>} />
                <Route path='/copy-history' element={<CopyHistory/>} />
                <Route path='/view-trades/:id' element={<TraderSingle/>} /> 
                <Route path='/view-copy/:id' element={<CopySingle/>} /> 
                
                <Route path='/plans' element={<InvestmentPlans/>} />
                <Route path='/wallet' element={<Wallet/>} />
                <Route path='/notifications' element={<ListNotifications/>} />
                <Route path='/profile' element={<Profile/>} />
                <Route path='/referrals' element={<Referrals/>} />
                <Route path='/push-notification' element={<PushNotification/>} />              
                <Route path='/withdrawals' element={<Withdrawals/>} />              
                <Route path='/investments' element={<Investment/>} />              
                <Route path='/transactions' element={<Transactions/>} />      
                <Route path='/cards' element={<Cards/>} />      
                <Route path='/shareholders' element={<Shareholders/>} />      
                <Route path='/loans' element={<Loans/>} />      
                <Route path='/markets' element={<MarketsAccount/>} /> 
                {/* new routes */}
                <Route path='/swap-coin' element={<SwapCoin/>} />
                <Route path='/receive' element={<Receive/>} />      
                <Route path='/send-coin' element={<SendCoin/>} />      
                <Route path='/trade' element={<DefaultTrader/>} />           
                <Route path='/trade-history' element={<TradeHistory/>} />           
                <Route path='/account-wallet' element={<NewWallet/>} />           
                <Route path='/start-trading' element={<StartTrading/>} />           
                <Route path='/spot-transfer' element={<SpotTransfer/>} />           
                <Route path='/package/:id' element={<CategoryPlans/>} />    

                <Route path='/buy' element={<Buy/>} />           
                <Route path='/sell' element={<Sell/>} />           
                <Route path='/p2p' element={<P2P/>} />
                <Route path='/p2p/transaction/:orderId' element={<P2PTransactionDetails/>} />
                <Route path='/p2p/order/:orderId' element={<P2POrderDetails/>} />
                <Route path='/p2p/history' element={<P2PHistory/>} />
                <Route path='/p2p-partner' element={<P2PPartnerDashboard/>} />
                           
                <Route path='/buyer' element={<Buyer/>} />           
                <Route path='/seller' element={<Seller/>} />
                <Route path='/payment/:id' element={<Transaction/>} />  
                <Route path='/assets' element={<Assets/>} />
                <Route path='/web3' element={<Web3/>} />
                <Route path='/trading-page' element={<TradeTab/>} />
                <Route path='/coin-chart' element={<CoinChart/>} />
                <Route path='/list-stock' element={<ListStock/>} />
                
                {/* admin routes */}

                {userRole === 'admin' &&
                <Fragment>
                  
                  <Route path='/list-loans' element={<ListLoans/>} />     
                  <Route path='/list-cards' element={<ListCards/>} />     
                  <Route path='/list-shareholders' element={<ListShareholders/>} />     
                  <Route path='/list-investments' element={<ListInvestments/>} />
                  <Route path='/depay-transactions' element={<DepayTransactions/>} />
                  <Route path='/coinremitter-transactions' element={<CoinremitterTransactions/>} />
                  <Route path='/list-withdrawals' element={<WithdrawalList/>} />
                  
                  <Route path='/list-users' element={<ListUsers/>} />
                  <Route path='/list-plans' element={<ListPlans/>} />
                  <Route path='/list-fundings' element={<ListFundings/>} />
                  <Route path='/edit-plan/:id' element={<EditPlan/>} />  
                  <Route path='/upload' element={<UploadProducts/>} />
                  <Route path='/send-mail' element={<AdminMail/>} />
                  <Route path='/send-sms' element={<AdminSms/>} />
                  <Route path='/create-trading-plans' element={<CreateTradingPlans/>} />
                  <Route path='/list-trading-plans' element={<ListTradingPlan/>} />
                  
                  <Route path='/create-plans' element={<CreatePlans/>} />
                  <Route path='/create-address' element={<CreateAddress/>} />
                  <Route path='/edit-address/:id' element={<Editwallet/>} />  
                  <Route path='/edit-trading-plan/:id' element={<EditTradingPlan/>} />  
                  
                  <Route path='/list-address' element={<ListAddresses/>} />
                  <Route path='/user-dashboard/:id' element={<UserDashboard/>} />             
                  <Route path='/create-category' element={<CreateCategories/>} />

                  {/* Copy trading */}
                  <Route path='/list-copiers' element={<ListCopiers/>} />
                  <Route path='/list-trades' element={<ListTrades/>} />
                  <Route path='/create-trades' element={<CreateTrades/>} />
                  <Route path='/create-trader' element={<CreateTrader/>} /> 
                  <Route path='/list-traders' element={<ListTraders/>} />
                  <Route path='/edit-trader/:id' element={<EditTrader/>} />   
                  <Route path='/edit-copier/:id' element={<Editcopier/>} /> 
                  <Route path='/edit-trade/:id' element={<EditTrade/>} /> 
                  <Route path='/edit-investment/:id' element={<EditInvestment/>} />

                  <Route path='/create-message' element={<CreateMessage/>} /> 
                  <Route path='/list-connections' element={<ListConnections/>} /> 

                  {/* Live Chat Admin Route */}
                  <Route path='/live-chats' element={<LiveChatAdmin />} />
                  <Route path='/live-chats/:chatId' element={<LiveChatAdmin />} />
                  <Route path='/list-referrals' element={<ListReferral/>} />
                  
                  {/* P2P Admin Route */}
                  <Route path='/p2p-admin' element={<P2PAdminDashboard/>} /> 

                </Fragment>
                }


                {userRole === 'editor' &&
                <Fragment>
                <Route path='/list-orders' element={<ListPlates/>} />
                <Route path='/upload' element={<UploadProducts/>} />
                <Route path='/list-transfers' element={<ListTransfer/>} /> 
                </Fragment>
                }
                <Route path="*" element={<MissingRoute/>} />
              </Routes>
              </PageWrapper>
            </Grid>
          </Grid>
        {/* Hide footer on P2P transaction and partner dashboard to avoid covering dialogs */}
        {!(window.location.pathname.startsWith('/p2p/transaction') || window.location.pathname.startsWith('/p2p-partner')) && (
          <Footer/>
        )}
        {message !== null &&
        <Snackbar sx={{ zIndex: 90999 }} open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={message.type} sx={{ width: '100%' }}>
            {message.message}
          </Alert>
        </Snackbar>
        }
        {/* {userRole === 'admin' && 
          <Fragment>
            <FetchAnalysis/>
            <ChartAnalysis/>
          </Fragment>        
        } */}
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open2}
          >
          <CircularProgress color="inherit" />
      </Backdrop>
        </ThemeProvider>
        </QueryClientProvider>
      
      {/* Live Chat Widget - Only show when not on admin chat page */}
       {/* {!(window.location.pathname.includes('/live-chats')) && <LiveChatWidget />} */}
      </div>
    );
  }else{
    return (
      <div className="App">
        <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <CheckAuth/>
        {/* <Header/>
        <SideBar/> */}
          <Grid container spacing={0}>
            {/* <Grid sx={{display: {md: 'flex', sm: 'none', xs: 'none'}}} item md={2}>
            <SideBarDesktop/>
            </Grid> */}
            <Grid item xs={12} md={10}>
              <PageWrapper>
              <Routes>   
                <Route path='/' element={<Login/>} />
                {/* <Route path='/wallet' element={<Wallet/>} /> */}
                <Route path='/notifications' element={<ListNotifications/>} />
                <Route path='/push-notification' element={<PushNotification/>} />             
                <Route path='/' element={<Index/>} />
                <Route path='/register' element={<Register/>} />
                <Route path='/login' element={<Login/>} />
                <Route path='/forgot' element={<Forgot/>} />
                <Route path='/invitation' element={<Invitation/>} />
                <Route path='/update-password' element={<UpdatePassword/>} />
                <Route path='/trading-page' element={<TradeTab/>} />

                {/* admin routes */}              
                <Route path="*" element={<MissingRoute/>} />
              </Routes>
              </PageWrapper>
            </Grid>
          </Grid>
        {message !== null &&
        <Snackbar sx={{ zIndex: 90999 }} open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={message.type} sx={{ width: '100%' }}>
            {message.message}
          </Alert>
        </Snackbar>
        }
        
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open2}
          >
          <CircularProgress color="inherit" />
      </Backdrop>

      {/* Live Chat Widget */}
      <LiveChatWidget />

        </ThemeProvider>
        </QueryClientProvider>
      </div>
    )
  }
  
}

export default App;
